module.exports = __webpack_public_path__ + "static/media/6-love.bf303f51.mp3";